import React from 'react';

import { components, type OptionProps } from '@atlaskit/select';
import { Flex } from '@atlassian/eoc-flex';
import PriorityBadge, { PRIORITIES } from '@atlassian/eoc-priority-badge';

import { type PriorityType } from '../../../common/types';

export const PriorityOption = <IsMulti extends boolean = false>(
	props: OptionProps<PriorityType, IsMulti>,
) => {
	return (
		<components.Option {...props}>
			<Flex columnGap={1} alignItems="center">
				{props.data.value === '{{priority}}' || !PRIORITIES[props.data.value] ? (
					props.data.label
				) : (
					<>
						<PriorityBadge priority={props.data.value} />
						{PRIORITIES[props.data.value].label}
					</>
				)}
			</Flex>
		</components.Option>
	);
};
